import { createSlice } from "@reduxjs/toolkit";
import { getUser } from "../../lib/storage";
const initialState = {
  loadingUsers: false,
  loadingUser: false,
  loadingUserInfo: false,
  loadingUserCreate: false,
  loadingUserUpdate: false,
  loadingUserDelete: false,

  errorLoadingUsers: null,
  errorLoadingUser: null,
  errorLoadingUserInfo: null,
  errorCreatingUser: null,
  errorUpdatingUser: null,
  errorDeletingUser: null,

  userInfo: getUser() || null,
  users: [],
  user: null,

  serverStatus: null,
  pagination: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoadingUsers(state) {
      state.loadingUsers = true;
      state.errorLoadingUsers = null;
    },
    setLoadingUser(state) {
      state.loadingUser = true;
      state.errorLoadingUser = null;
    },
    setLoadingUserInfo(state) {
      state.loadingUserInfo = true;
      state.errorLoadingUserInfo = null;
    },
    setLoadingUserCreate(state) {
      state.loadingUserCreate = true;
      state.errorCreatingUser = null;
    },
    setLoadingUserUpdate(state) {
      state.loadingUserUpdate = true;
      state.errorUpdatingUser = null;
    },
    setLoadingUserDelete(state) {
      state.loadingUserDelete = true;
      state.errorDeletingUser = null;
    },

    setErrorLoadingUsers(state, { payload }) {
      state.loadingUsers = false;
      state.errorLoadingUsers = payload;
    },
    setErrorLoadingUser(state, { payload }) {
      state.loadingUser = false;
      state.errorLoadingUser = payload;
    },
    setErrorLoadingUserInfo(state, { payload }) {
      state.loadingUserInfo = false;
      state.errorLoadingUserInfo = payload;
    },
    setErrorCreatingUser(state, { payload }) {
      state.loadingUserCreate = false;
      state.errorCreatingUser = payload;
    },
    setErrorUpdatingUser(state, { payload }) {
      state.loadingUserUpdate = false;
      state.errorUpdatingUser = payload;
    },
    setErrorDeletingUser(state, { payload }) {
      state.loadingUserDelete = false;
      state.errorDeletingUser = payload;
    },
    userLoginSuccess(state, { payload }) {
      state.userInfo = payload;
      state.loadingUserInfo = false;
      state.errorLoadingUserInfo = null;
    },
    userLogout(state) {
      state.userInfo = null;
      state.user = null;
      state.users = [];
      state.loadingUserInfo = false;
      state.errorLoadingUserInfo = null;
    },

    setUsers(state, { payload }) {
      state.loadingUsers = false;
      state.errorLoadingUsers = null;
      state.users = payload;
    },

    setUser(state, { payload }) {
      state.loadingUser = false;
      state.errorLoadingUser = null;
      state.user = payload;
    },

    createUserSuccess(state, { payload }) {
      state.users = [payload, ...state.users];
      state.loadingUserCreate = false;
      state.errorCreatingUser = null;
    },

    updateUserSuccess(state, { payload }) {
      state.users = state.users.map((u) => (u.id === payload.id ? payload : u));

      if (state.user && state.user.id === payload.id) {
        state.user = payload;
      }

      state.loadingUserUpdate = false;
      state.errorUpdatingUser = null;
    },

    deleteUserSuccess(state, { payload: idToDelete }) {
      state.users = state.users.filter((u) => u.id !== idToDelete);

      if (state.user && state.user.id === idToDelete) {
        state.user = null;
      }

      state.loadingUserDelete = false;
      state.errorDeletingUser = null;
    },

    setServerResponseStatus(state, { payload }) {
      state.serverStatus = payload;
    },
    setPagination: (state, { payload }) => {
      state.pagination = payload;
    },
  },
});

export const {
  setLoadingUsers,
  setLoadingUser,
  setLoadingUserInfo,
  setLoadingUserCreate,
  setLoadingUserUpdate,
  setLoadingUserDelete,
  setErrorLoadingUsers,
  setErrorLoadingUser,
  setErrorLoadingUserInfo,
  setErrorCreatingUser,
  setErrorUpdatingUser,
  setErrorDeletingUser,
  userLoginSuccess,
  userLogout,
  setUsers,
  setUser,
  createUserSuccess,
  updateUserSuccess,
  deleteUserSuccess,
  setServerResponseStatus,
  setPagination,
} = userSlice.actions;

export default userSlice.reducer;

export const selectUser = (state) => state.user;
